import { useDispatch, useSelector } from 'react-redux';
import {
  BannerKeys,
  BannerPreferencesActions,
  getBannerPrefsHidden,
} from '../redux/banner_preferences';

export const useBannerPreferences = () => {
  const dispatch = useDispatch();
  const hiddenBanners = useSelector(getBannerPrefsHidden);

  const setBannerPreferencesHidden = (key: BannerKeys) => {
    dispatch(BannerPreferencesActions.BANNER_PREFERENCES_HIDDEN_SAVE(key));
  };

  const isBannerHidden = (key: BannerKeys) => {
    return hiddenBanners.includes(key) || hiddenBanners.length >= 2;
  };

  return {
    setBannerPreferencesHidden,
    isBannerHidden,
  };
};
